import { useFieldProps } from 'hooks';
import React from 'react';
import { Controller } from 'react-hook-form';
import { getHandlerKayPress } from 'utils/handlers';

import style from './index.module.scss';
import { IDataGridLightEditorProps, useDataGridLightEditorForm } from 'components/data-grid-light';
import { AppInput } from 'components/app-input';
import { composeFunctions } from 'utils';

interface Props extends IDataGridLightEditorProps<any, any> {}

export const EditorString: React.FC<Props> = ({ row, field, onClose, onSubmit }) => {
  const { control, handleSubmit, errors } = useDataGridLightEditorForm({
    row,
    field,
    onClose,
  });
  const getFieldProps = useFieldProps({ errors, emptyHelperText: ' ' });

  const submit = handleSubmit(onSubmit);

  return (
    <div className={style.root}>
      <Controller
        name={String(field)}
        control={control}
        render={(renderProps) => {
          const props = getFieldProps(renderProps);
          return (
            <AppInput
              {...props}
              autoFocus
              fullWidth
              label={null}
              onKeyUp={getHandlerKayPress('Enter', submit)}
              onBlur={composeFunctions(props.onBlur, submit, onClose)}
              helperText={props.helperText === ' ' ? null : props.helperText}
            />
          );
        }}
      />
    </div>
  );
};
